import { Button, Container } from "react-bootstrap";
import styles from "../../assets/styles/AuthPage.module.css";
import stylesUtils from "../../assets/styles/utils.module.css";
import stylesButtons from "../../assets/styles/buttons.module.css";
import { Link, Navigate } from "react-router-dom";
import { Administrator } from "../../services/models/administrator";
import { SubUser } from "../../services/models/sub_user";

interface AuthPageProps {
    loggedInUser?: Administrator | SubUser | null;
}

function isAdministrator(obj: any): obj is Administrator {
    return obj?.role === undefined;
}

function isSubUser(obj: any): obj is SubUser {
    return obj?.role !== undefined;
}

const AuthPage = ({ loggedInUser }: AuthPageProps) => {
    // Если пользователь залогинен, перенаправляем на соответствующую страницу
    if (loggedInUser) {
        if (isAdministrator(loggedInUser)) {
            return <Navigate to="/administrator/cabinet" replace />;
        } else if (isSubUser(loggedInUser)) {
            return <Navigate to="/user/cabinet" replace />;
        }
    }

    return (
        <Container className={styles.authPage}>
            <h1 className={styles.authTitle}>Авторизация</h1>
            <Link to="/administrator" className={stylesButtons.noLoneLink}>
                <Button className={`${stylesUtils.flexSizeButton} ${stylesUtils.flexCenter} ${stylesButtons.authButton }` }>
                    Авторизация администратора
                </Button>
            </Link>
            <Link to="/user" className={stylesButtons.noLoneLink}>
                <Button className={`${stylesUtils.flexSizeButton} ${stylesUtils.flexCenter} ${stylesButtons.authButton }` }>
                    Авторизация пользователя
                </Button>
            </Link>
        </Container>
    )
}

export default AuthPage;